<script>
export default {
    props: ['integrations'],
    data() {
        return {
            filter: {
                tagId: null,
                type: null
            },
            initalLoad: false,
            searchIntegration: null
        };
    },
    computed: {
        noFilter() {
            return this.filter.tagId === null && this.filter.type === null;
        },
        integrationsFiltered() {
            let integrations = JSON.parse(JSON.stringify(this.integrations));

            if(this.noFilter) {
                if(this.searchIntegration !== null) {
                    integrations = integrations.filter(x => x.name.toLowerCase().indexOf(this.searchIntegration) > -1 );
                }
				
                return integrations;
            } else {
                if (this.filter.type) {
                    integrations = integrations.filter(x => x.type === this.filter.type);
                }

                if (this.filter.tagId) {
                    integrations = integrations.filter(
                        integration => integration.tags.find(tag => tag.id === this.filter.tagId)
                    );
                }

                if(this.searchIntegration !== null) {
                    integrations = integrations.filter(x => x.name.toLowerCase().indexOf(this.searchIntegration) > -1 );
                }

                return integrations;
            }
        }
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/Integrations.vue